import { blockCategories } from '../../../categories';
import initTabsScript from './tabsScript';

export default function Tabs(editor, opts = {}) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    const defaultOpts = {
        defaultItems: 3,
    };

    opts = {
        category: blockCategories.basic,
        label: 'Tabs',
        block: {},
        ...defaultOpts,
        ...opts,
    };

    const createBtnItem = (tabsId, index) => {
        const itemId = `tab-btn_${tabsId}_${index}`;
        return {
            type: 'tab-btn',
            attributes: {
                'data-target-btn': `${itemId}`,
            },
            droppable: true,
            components: {
                type: 'text',
                content: `Tab ${parseInt(index) + 1}`,
                editable: true,
                droppable: false,
                draggable: false,
            },
        };
    };

    const createPanelItem = (tabsId, index) => {
        const itemId = `tab-panel_${tabsId}_${index}`;
        return {
            type: 'tab-panel',
            attributes: {
                'data-target-panel': `${itemId}`,
            },
            droppable: true,
            components: {
                type: 'text',
                content: `Content ${parseInt(index) + 1}`,
                editable: true,
                droppable: false,
                draggable: false,
            },
        };
    };

    domComponents.addType('tab-btn', {
        isComponent: (el) => el.dataset?.type === 'tab-btn',
        model: {
            defaults: {
                tagName: 'div',
                draggable: ['tabs-nav'],
                droppable: true,
                editable: true,
                attributes: { 'data-type': 'tab-btn', class: 'tabs-btn' },
                components: 'Tab',
                label: 'Tab Button',
            },
        },
    });

    domComponents.addType('tabs-nav', {
        isComponent: (el) => el.dataset?.type === 'tabs-nav',
        model: {
            defaults: {
                tagName: 'div',
                draggable: ['tabs'],
                droppable: true,
                attributes: { 'data-type': 'tabs-nav' },
                label: 'Tabs Nav',
            },
        },
    });

    domComponents.addType('tab-panel', {
        isComponent: (el) => el.dataset?.type === 'tab-panel',
        model: {
            defaults: {
                tagName: 'div',
                draggable: ['tabs-content'],
                droppable: true,
                editable: true,
                attributes: { 'data-type': 'tab-panel', class: 'tabs-panel' },
                components: 'Tab content',
                label: 'Tab Panel',
            },
        },
    });

    domComponents.addType('tabs-content', {
        isComponent: (el) => el.dataset?.type === 'tabs-content',
        model: {
            defaults: {
                tagName: 'div',
                draggable: ['tabs'],
                droppable: ['tab-panel'],
                attributes: { 'data-type': 'tabs-content' },
                label: 'Tabs Content',
            },
        },
    });

    domComponents.addType('tabs', {
        isComponent: (el) => el.dataset?.type === 'tabs',
        model: {
            defaults: {
                tagName: 'div',
                draggable: true,
                droppable: ['tabs-nav', 'tabs-content'],
                attributes: {
                    'data-type': 'tabs',
                    class: 'tabs sio-tabs',
                    id: `tabs-${Date.now()}-${Math.floor(
                        Math.random() * 100000
                    )}`,
                },
                label: 'Tabs',
                components: [
                    {
                        type: 'tabs-nav',
                        components: [],
                    },
                    {
                        type: 'tabs-content',
                        components: [],
                    },
                ],
            },
            init() {
                const tabsId = this.get('attributes').id;
                const tabsNav = this.components().find(
                    (comp) => comp.get('type') === 'tabs-nav'
                );
                const tabsContent = this.components().find(
                    (comp) => comp.get('type') === 'tabs-content'
                );

                if (!tabsNav || !tabsContent) return;

                if (
                    tabsNav.components().length ||
                    tabsContent.components().length
                ) {
                    return;
                }

                for (let i = 0; i < opts.defaultItems; i++) {
                    tabsNav.append(createBtnItem(tabsId, i));
                    tabsContent.append(createPanelItem(tabsId, i));
                }
            },
        },
    });

    const initTabsScripts = () => {
        const canvasDoc = editor.Canvas.getDocument();
        if (!canvasDoc) return;

        canvasDoc.querySelectorAll('.tabs.sio-tabs').forEach((tabsEl) => {
            initTabsScript(tabsEl);
        });
    };

    editor.Commands.add('tabs:init-scripts', {
        run() {
            initTabsScripts();
        },
    });

    const delayedInit = () => setTimeout(initTabsScripts, 100);
    editor.on('storage:end:load', delayedInit);
    editor.on('load', delayedInit);
    editor.on('update:canvas', delayedInit);
    editor.on('component:mount', (component) => {
        let tabsComponent = component;
        if (component.get('type') !== 'tabs') {
            let parent = component.parent();
            while (parent && parent.get('type') !== 'tabs') {
                parent = parent.parent();
            }
            if (!parent) return;
            tabsComponent = parent;
        }
        initTabsScript(tabsComponent.getEl?.());
    });

    blockManager.add('tabs-block', {
        label: opts.label,
        category: opts.category,
        media: `<svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M3 4h18v4H3V4zm0 6h10v10H3V10zm12 0h6v10h-6V10z"/>
    </svg>`,
        content: { type: 'tabs' },
        ...opts.block,
    });
}
